<template>
  <div class="productPackMembersBig">
    <div class="productPackMembersBig__list">
      <nuxt-link
        v-for="item in members"
        :key="item.slug"
        class="productPackMembersBig__item"
        :to="localePath({ name: 'product-slug', params: { slug: item.slug } })"
        @click.native="gTagProductClick(item)"
      >
        <div class="productPackMembersBig__itemImage">
          <new-image-box
            :alt="item.name"
            :src="item.mainPictureUrl"
            :width="100"
            :height="80"
            loading="lazy"
            image-params="w_100,h_80"
          />
        </div>
        <div>
          <div class="productPackMembersBig__itemName">{{ item.quantity }}x{{ item.name }}</div>
          <div class="productPackMembersBig__itemCode">
            Kod: <b>{{ item.code }}</b>
          </div>
        </div>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import NewImageBox from '@/components/NewImageBox';
export default {
  name: 'ProductPackMembersBig',
  components: { NewImageBox },
  props: {
    members: {
      type: Array,
      default: () => {},
    },
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hoverVariant: [],
      isCollapse: false,
    };
  },
  methods: {
    toggle() {
      this.isCollapse = this.isCollapse !== true;
    },
    gTagProductClick(item) {
      const categories = this.product.category.namesInPath.reduce((acc, curr, index) => {
        acc['category' + (index === 0 ? '' : index + 1)] = curr;
        return acc;
      }, {});

      this.$gtm.push({ ecommerce: null });
      this.$gtm.push({
        event: 'select_item',
        ecommerce: {
          item_list_id: '',
          item_list_name: '',
          items: [
            {
              item_id: item.id,
              item_name: item.name,
              discount: 0,
              brand: this.product.brand ? this.product.brand.name : '',
              ...categories,
              item_list_id: '',
              item_list_name: '',
              price: item.priceGross,
              variant: '',
              quantity: 1,
            },
          ],
        },
      });
    },
  },
};
</script>

<style lang="scss">
.productPackMembersBig {
  $root: &;

  &__item {
    align-items: center;
    display: flex;
    border-bottom: 1px solid $cAddLight;
    padding: 1.5rem 0;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }

    &:hover {
      #{$root}__itemName {
        color: $cSec;
      }
    }
  }

  &__itemImage {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 12rem;
    max-width: 12rem;
    margin-right: 2rem;

    @include rwd('tablet') {
      flex: 0 0 9rem;
      max-width: 9rem;
    }
  }

  &__itemName {
    font-size: 1.6rem;
    font-weight: 600;
    line-height: 2.4rem;
    color: $cMainNeutral;
    transition: $tr;
  }

  &__itemCode {
    margin-top: 1rem;
    font-size: 1.2rem;
    line-height: 1.4rem;
    color: $cMainNeutral;

    b,
    strong {
      font-weight: 700;
    }
  }
}
</style>
